/** sessionStorage key: ad slot preview mode for Jacob (before AdSense approval). */
export const AD_PREVIEW_SESSION_KEY = "mapus.adpreview";

export type AdPreviewUrlFlag = "on" | "off" | null;

export interface AdPreviewStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** Parse `?adpreview=1|0` from a location search string. */
export function adPreviewFromSearch(search: string): AdPreviewUrlFlag {
  const rawSearch = search.startsWith("?") ? search.slice(1) : search;
  if (!rawSearch) return null;
  const v = new URLSearchParams(rawSearch).get("adpreview");
  if (v == null) return null;
  const n = v.trim().toLowerCase();
  if (n === "1" || n === "true" || n === "yes" || n === "on") return "on";
  if (n === "0" || n === "false" || n === "no" || n === "off") return "off";
  return null;
}

export function applyAdPreviewSession(flag: AdPreviewUrlFlag, storage: AdPreviewStorage): void {
  if (flag === "on") storage.setItem(AD_PREVIEW_SESSION_KEY, "1");
  else if (flag === "off") storage.removeItem(AD_PREVIEW_SESSION_KEY);
}

export function readAdPreviewSession(storage: Pick<AdPreviewStorage, "getItem">): boolean {
  return storage.getItem(AD_PREVIEW_SESSION_KEY) === "1";
}

/** Apply URL flag to sessionStorage and return whether preview mode is active. */
export function syncAdPreviewFromSearch(search: string, storage: AdPreviewStorage): boolean {
  applyAdPreviewSession(adPreviewFromSearch(search), storage);
  return readAdPreviewSession(storage);
}

/** Min heights for responsive display units (matches web/src/style.css). */
export const AD_SLOT_MIN_HEIGHT = {
  quest: 280,
  home: 250,
} as const;

export type AdSlotSizeKey = keyof typeof AD_SLOT_MIN_HEIGHT;

export function adSlotSizeLabel(key: AdSlotSizeKey): string {
  return `min ${AD_SLOT_MIN_HEIGHT[key]}px · responsive`;
}

/** In-feed list card slot (proposed); height aligns with route thumbnail row. */
export const AD_FEED_CARD_SIZE_LABEL = "96×68 · card";
